import React, {useEffect, useState} from "react";
import {styled, useTheme} from "@mui/material/styles";
import {Box, Button, Divider, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import OrganizationService from "../api/organization";
import {useSelector} from "react-redux";
import TemplateTable from "../common/Layout/templatePages/templateTable";
import {useNavigate} from "react-router-dom";
import Breadcrumbs from "../common/breadcrumbs";

const StyledButton = styled((props) => <Button {...props} />)(({theme}) => ({
    "height": "36px",
    "backgroundColor": theme.palette.custom.buttonColor,
    "color": theme.palette.custom.buttonTextColor,
    "&:hover": {
        backgroundColor: theme.palette.custom.buttonHoverColor,
        color: theme.palette.custom.buttonHoverTextColor,
        boxShadow: "none"
    },
    "float": "right",
    "width": "min-content",
    "whiteSpace": "nowrap",
    "padding": "1rem"
}));

function ApiKeys() {
    const theme = useTheme();
    const navigate = useNavigate();
    const {t} = useTranslation();
    const organization = useSelector(({organziation}) => organziation);
    const [loadingValue, setLoadingValue] = useState(true);
    const [apiKeys, setApiKeys] = useState([]);

    const breadcrumbs = [
        {id: 0, name: "Home", href: "/"},
        {id: 1, name: t("Api Keys"), href: "apiKeys"}
    ];

    useEffect(() => {
        if (organization) {
            OrganizationService.GetApiKeys("", "", "active", "MTIxMnwxfDN8MjE5OS0wMS0wMSAwMDowMDowMA")
                .then((json) => {
                    if (json) setApiKeys(json.app);
                    setLoadingValue(false);
                })
                .catch((error) => {
                    setLoadingValue(false);
                    if (process.env.NODE_ENV === "development") console.log("GetApiKeys error", error);
                });
        }
    }, [organization]);

    const handleButton = (event, buttonType, row) => {
        event.stopPropagation();
        if (buttonType === "edit") {
            navigate(`/addEditApiKey?api_key_id=${row.api_key_id}`);
        }
    };
    const handleAddNew = (event) => {
        event.stopPropagation();
        navigate(`/addEditApiKey`);
    };

    return (
        <Box
            sx={{
                p: "12px",
                backgroundColor: theme.palette.custom.backgroundColor
            }}>
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: {xs: "block", sm: "center"},
                    gap: "1rem",
                    mb: "1rem",
                    flexWrap: "wrap"
                }}>
                <Typography sx={{fontSize: "45px", mb: 0, color: theme.palette.custom.text}} variant="h2" gutterBottom>
                    {t("Api Keys")}
                </Typography>
                <StyledButton variant="contained" onClick={handleAddNew}>
                    {t("Add Api Key")}
                </StyledButton>
            </Box>
            <Divider sx={{mb: "10px", backgroundColor: theme.palette.custom.borderColor}} />
            <TemplateTable
                headCells={[
                    {id: "operation_full_name", label: "Organization"},
                    {id: "key", label: "Api Key"},
                    {id: "expiry_date", label: "Expiry Date"},
                    {id: "super_key", label: "Super Key"},
                    {id: "status", label: "Status"},
                    {id: "created_timestamp", label: "Created Timestamp"},
                    {id: "updated_timestamp", label: "Updated Timestamp"},
                    {
                        id: "action",
                        buttons: ["edit"]
                    }
                ]}
                handleButton={handleButton}
                itemsList={apiKeys}
                itemId="api_key_id"
                orderBy="operation_full_name"
                loading={loadingValue}
                searchAttributes={["operation_full_name", "key", "status"]}
                allowExport
                exportTitle={t("Api Keys")}
            />
        </Box>
    );
}
export default ApiKeys;
